import styled, { css } from 'styled-components';
//@ts-ignore
import { InlineSkeleton } from '@mindtickle/skeleton';
//@ts-ignore
import Icon, { ICON_MAP } from '@mindtickle/icon';
//@ts-ignore
import { brandColors } from '@mindtickle/styles/lib'; // this will be from custom brand-colors
import { useUserAuth } from '~/components/Auth';

const StyledAside = styled.aside`
  width: 64px;
  flex: 0 0 64px;
  position: relative;
`;

const StyledSiderChildren = styled.div`
  height: 100%;
  margin-top: -0.1px;
  padding-top: 0.1px;
`;

const StyledContentMenu = styled.ul`
  height: 100vh;
  /* Need to revisit: Due to consumed from brandColors object, not replacing it with token as of now */
  background: ${brandColors.CONGRESS_BLUE};
  list-style: none;
  outline: none;
  padding: 0;
  margin: 0;
`;

const StyleSidebarMenuItem = styled.li`
  margin: 0px 16px 16px;
  background-color: transparent;
  color: ${brandColors.MANATEE};
  border-radius: 6px;

  &:hover {
    background-color: ${brandColors.PICKLED_BLUEWOOD};
    color: ${brandColors.WHITE};
  }
`;

const StyledIconSkeleton = styled(InlineSkeleton)`
  &&&& {
    min-width: unset;
    height: 32px;
  }
`;

const StyledStaticIcon = styled.li`
  padding-top: 24px;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
`;

const StyledStaticFirstIcon = styled.li`
  padding-top: 24px;
  margin-bottom: 16px;
`;

const staticIconStyles = css`
  font-size: 16px;
`;

const getSidebarMenuItemSkeleton = (iconCount = 2) => {
  let list = [];
  for (let itr = 0; itr < iconCount; itr++) {
    list.push(
      <StyleSidebarMenuItem role="menuitem" key={itr}>
        <StyledIconSkeleton active style={{ width: 32, height: 32 }} />
      </StyleSidebarMenuItem>
    );
  }
  return <>{list}</>;
};

export default () => {
  const { company } = useUserAuth();
  const isHomeIconHidden = company?.companySettings?.isExperienceCloudEnabled;

  return (
    <StyledAside>
      <StyledSiderChildren>
        <StyledContentMenu>
          {isHomeIconHidden ? (
            <StyledStaticFirstIcon>{getSidebarMenuItemSkeleton(1)}</StyledStaticFirstIcon>
          ) : (
            <StyledStaticIcon role="menuitem">
              <Icon type={ICON_MAP.HOME} css={staticIconStyles} />
            </StyledStaticIcon>
          )}
          {getSidebarMenuItemSkeleton()}
        </StyledContentMenu>
      </StyledSiderChildren>
    </StyledAside>
  );
};
